<template lang="pug">
    <div class="body-wrapper">
    <div>
        <nav-bar/>
        <div class="notifications">
            <div class="main-panel">
                <div class="content-wrapperr">
                    <div class="title"><h2 class="head-title">Notifications</h2></div>
                    <div class="notification-lists">
                        <ul>
                            <li v-for="(notification, idx) in notificationData" :key="'noti-' + idx">
                                <!--
                                <div class="c-logo">
                                    <a @click.prevent>logo</a>
                                </div>
                                -->
                                <!-- <p><span class="c-name">Leapfrog</span> has submitted progess file on <span class="job-id">JOBID W1-1009</span></p> -->
                                <router-link
                                :style="notification.read_at? 'text-decoration:none;color: #3a3b45' : 'text-decoration:none'"
                                exact
                                v-on:click.native="
                                    markNotificationAsRead(notification)
                                "
                                :to="{
                                    name: setRouteName(notification.data.type),
                                    params: {
                                    id: notification.data.action_id,
                                    },
                                }"
                                >
                                <p>{{notification.data.text}}</p>
                                <span class="days">{{momentDateFromNow(notification.created_at)}}</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

            <div class="datagrid-footer" v-if="lastPage > 1">
                <b-pagination
                    pills
                    align="left"
                    :total-rows="total"
                    v-model="currentPage"
                    :page-count="lastPage"
                    :per-page="perPage"                     
                    hide-goto-end-buttons="true"
                ></b-pagination>
            </div>
        </div>
    </div>

</template>

<script>
import NavBar from "./includes/NavBar.vue";
import NotificationRouteMixin from "@mixins/notificationRouteMixin.js";
import moment from "moment";

export default {
    components: {
        NavBar,
    },
     mixins: [NotificationRouteMixin],
     data() {
        return {
            currentPage: 1,
            total: 0,
            perPage: 5,
            notificationData: {},
        };
    },
      mounted() {
        this.filter();
    },
      methods: {
          filter(page = 1) {
              axios.post("api/manager/notifications", {
                  page: page,
              }).then((response) => {
                this.currentPage = response.data.current_page;
                this.total = response.data.total;
                this.perPage = response.data.per_page;
                this.lastPage = response.data.last_page;
                this.notificationData = response.data.notifications;  
            });
          },
          momentDateFromNow(date) {
            return moment(date).fromNow();
          },
          markNotificationAsRead(notification){
            if (notification.read_at) return;
            axios.post("api/manager/markNotificationAsRead", {
                uuid : notification.id
            }).then((response) => {
            });
          },
      },
       watch: {
        currentPage: {
            handler: function (value) {
                this.filter(value);
            },
        },
    },
};
</script>
<style scoped>
    .body-wrapper
    {
        background-color: #F7F7FC;
    }

    .title {
        border-bottom: 1px solid #d9dbe9;
        width: 100%;
    }

    h2.head-title
    {
        font-size: 1rem;
        color: #000;
        text-transform: uppercase;
        padding: 0.5rem 1rem;
        font-weight: 500;
        margin-bottom: 0;
    }

    li {
        list-style: none;
    }

</style>